import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import { AppSettings, UserAppInfo } from '../components';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  '> *': {
    margin: theme.spacing(1),
  },
}));

export const CardBasicInfo = styled(Card)(({ theme }) => ({
  borderRadius: 2,
  [theme.breakpoints.up('sm')]: {
    marginRight: '20%',
    marginLeft: '20%',
  },
}));

const Profile = () => (
  <Container>
    <CardBasicInfo elevation={4}>
      <CardContent>
        <UserAppInfo />
      </CardContent>
    </CardBasicInfo>
    <CardBasicInfo elevation={4}>
      <CardContent>
        <AppSettings />
      </CardContent>
    </CardBasicInfo>
  </Container>
);

export default Profile;
